import React from 'react';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import { SignInModal as AccountFormModal } from '@ratehub/base-ui';


function AccountModal({ modalModel, ...others }) {
    return (
        <AccountFormModal
            onClose={() => modalModel.close()}
            messages={Messages}
            {...others}
        />
    );
}

AccountModal.propTypes = {
    modalModel: PropTypes.shape({
        isOpen: PropTypes.bool.isRequired,
        close: PropTypes.func.isRequired,
        accept: PropTypes.func.isRequired,
        reject: PropTypes.func.isRequired,
    }).isRequired,
};


const Messages = {
    signInForm: defineMessages({
        SIGN_IN_TITLE: {
            id: 'Dashboard.SignInForm.title.text',
            defaultMessage: 'Sign in',
        },
        SIGN_IN_CTA: {
            id: 'Dashboard.SignInForm.signInCta.label',
            defaultMessage: 'Sign in',
        },
    }),
    registerForm: defineMessages({
        REGISTER_TITLE: {
            id: 'Dashboard.RegisterForm.title.text',
            defaultMessage: 'Sign up',
        },
        REGISTER_CTA: {
            id: 'Dashboard.RegisterForm.signInCta.label',
            defaultMessage: 'Sign up',
        },
    }),
    registerFormWithLink: defineMessages({
        REGISTER_TITLE: {
            id: 'Dashboard.RegisterFormWithLink.title.text',
            defaultMessage: 'Sign up to review quote',
        },
        REGISTER_CTA: {
            id: 'Dashboard.RegisterFormWithLink.signInCta.label',
            defaultMessage: 'Sign up',
        },
    }),
};

export default observer(AccountModal);
